// JS Controller for global methods and functions

import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ["formErrors"]

  connect() {
    this.element[this.identifier] = this
  }

  // Error form
  onPostError(event) {
    $.modal.close()
    const confirmButton = document.querySelector('[data-donations-target="btnConfirmForm"]')
    if (confirmButton) {
      confirmButton.disabled = false
    }
    if (!this.hasFormErrorsTarget) { return }

    this.formErrorsTarget.innerText = ""
    const xhr = event.detail && event.detail[2]
    this.parseErrorResponse(xhr).forEach((error) => {
      const li = document.createElement("li")
      li.appendChild(document.createTextNode(error))
      this.formErrorsTarget.appendChild(li)
    })
    const firstError = this.formErrorsTarget.querySelector("li")
    if (firstError) {
      firstError.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }

  parseErrorResponse(xhr) {
    const fallback = ["Something went wrong processing your donation. Please refresh the page and try again."]
    if (!xhr || xhr.response == null || xhr.response === "") {
      return fallback
    }

    try {
      const parsed = JSON.parse(xhr.response)
      if (Array.isArray(parsed)) {
        const messages = parsed.filter(Boolean).map(String)
        return messages.length ? messages : fallback
      }
      if (typeof parsed === "string" && parsed.trim()) {
        return [parsed]
      }
      if (parsed && typeof parsed === "object") {
        const candidate = parsed.errors || parsed.error || parsed.message
        if (Array.isArray(candidate)) {
          const messages = candidate.filter(Boolean).map(String)
          return messages.length ? messages : fallback
        }
        if (candidate) {
          return [String(candidate)]
        }
      }
    } catch (e) {
      // HTML error pages (CSRF 422, 500) start with "<" and are not JSON.
    }

    return fallback
  }

  // Success form
  onPostSuccess(event) {
    this.formErrorsTarget.innerText = ""
    let [data, status, xhr] = event.detail
  }

  scrollTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  submitForm(elem) {
    Rails.fire(elem, "submit")
  }
}
